// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PriceComponent_wrapper___O9Tc","componentRow":"PriceComponent_componentRow__AqBKx","shimmer":"PriceComponent_shimmer__my7zR"};